<script lang="ts">
  import { Folders } from "../../../utils/Constant/Constant";
  import data from "../../../Data/FileManager/FileManager.json";
    
</script>
<h5 class="mt-4">{Folders}</h5>
<ul class="folder">
    {#each data.floderdata as folderItem}
        <li class="folder-box">
            <div class="media">
                <i class="fa fa-{folderItem.icon}-o f-36 txt-warning" />
                <div class="media-body ms-3">
                    <h6 class="mb-0">{folderItem.title}</h6>
                    <p>{folderItem.space}</p>
                </div>
            </div>
        </li>
    {/each}
</ul>